var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"gallery btn",on:{"click":function($event){return _vm.storeGallerySet(_vm.gallery)}}},[_vm._v("\n    View gallery "),_c('font-awesome-icon',{attrs:{"icon":['fal', 'expand'],"full-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }